exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".orderTable{margin-top:20px}.rateTable{margin:0 0 50px}.centerDiv{text-align:center;margin:20px 0 10px;cursor:pointer}.centerDiv p{font-size:16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.iconDiv{margin-top:-51px}\n", ""]);

// exports
